import React from 'react';
import{ AuthProvider } from './AuthContext';
import { AuthInterceptor } from '../Components/Auth/AuthInterceptor'
import { AppRoutes } from '../Routes/Routes'
import GlobalNotificationBar from '../Components/Common/GlobalNotificationBar';
import { CategoryProvider } from '../Components/Common/Context/Context';


const App = () => {
  AuthInterceptor();
  // CheckLoginUser();
  return (
    <AuthProvider>
      <CategoryProvider>
      <GlobalNotificationBar />
      <AppRoutes />
     </CategoryProvider>
    </AuthProvider>
  );
};

export default App;
